const PauseIcon = (props) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.24 30.8125H7.0975C4.4625 30.8125 3.1875 29.5942 3.1875 27.0725V6.9275C3.1875 4.40583 4.4625 3.1875 7.0975 3.1875H12.24C14.875 3.1875 16.15 4.40583 16.15 6.9275V27.0725C16.15 29.5942 14.875 30.8125 12.24 30.8125ZM7.0975 5.3125C5.5675 5.3125 5.3125 5.695 5.3125 6.9275V27.0725C5.3125 28.305 5.55333 28.6875 7.0975 28.6875H12.24C13.77 28.6875 14.025 28.305 14.025 27.0725V6.9275C14.025 5.695 13.7842 5.3125 12.24 5.3125H7.0975Z"
      fill="#292D32"
    />
    <path
      d="M26.9026 30.8125H21.7601C19.1251 30.8125 17.8501 29.5942 17.8501 27.0725V6.9275C17.8501 4.40583 19.1251 3.1875 21.7601 3.1875H26.9026C29.5376 3.1875 30.8126 4.40583 30.8126 6.9275V27.0725C30.8126 29.5942 29.5376 30.8125 26.9026 30.8125ZM21.7601 5.3125C20.2301 5.3125 19.9751 5.695 19.9751 6.9275V27.0725C19.9751 28.305 20.2159 28.6875 21.7601 28.6875H26.9026C28.4326 28.6875 28.6876 28.305 28.6876 27.0725V6.9275C28.6876 5.695 28.4468 5.3125 26.9026 5.3125H21.7601Z"
      fill="#292D32"
    />
  </svg>
);
export default PauseIcon;
